// CN marketplace configurations related to Search scope.

// The maximum length of search keywords' history
export const MAX_HISTORY_KEYWORDS_LIST_LENGTH = 30;
